<template>
  <div class="related-guides">
    <h2 class="related-guides__header">Написали статью вместе с гидами</h2>
    <div class="related-guides__list">
      <related-guide-card
        v-for="guide in mergedGuides"
        :key="guide.id"
        v-bind="guide"
        @guide-clicked="handleGuideClick"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, inject } from 'vue';

  import type { ArticleContent } from '@/features/articleContent';
  import type { ApiGuide } from '@/features/articleContent/lib/articleComponents';
  import { mapApiGuideForRelatedCard } from '@/features/articleContent/lib/mapApiGuideForBlocks';
  import RelatedGuideCard, { type Props as Guide } from './Card.vue';

  interface GuideInfo {
    id?: number;
    description?: ArticleContent;
  }

  interface Props {
    guides?: GuideInfo[];
    postGuides?: ApiGuide[];
  }

  const props = withDefaults(defineProps<Props>(), { guides: () => [] });

  const sendGuideClickEvent = inject<((guideId: number, clickType: string) => void) | undefined>('sendGuideClickEvent');

  const handleGuideClick = (guideId: number) => {
    if (sendGuideClickEvent) {
      sendGuideClickEvent(guideId, 'participant');
    }
  };

  const mergedGuides = computed((): Guide[] => {
    const postList = Array.isArray(props.postGuides) ? props.postGuides : [];
    const byId = new Map(postList.map((api) => [Number(api.id), mapApiGuideForRelatedCard(api)]));
    const result: Guide[] = [];

    for (const guide of props.guides) {
      const guideId = guide.id;
      if (guideId == null || !guide.description) {
        continue;
      }
      const related = byId.get(guideId);
      if (related) {
        result.push({ ...related, description: guide.description });
      }
    }
    return result;
  });
</script>

<style lang="scss" scoped>
  .related-guides {
    max-width: var(--width-content);
    margin-top: var(--alias-space-32);
  }

  .related-guides__header {
    @include base-700-500-extra;
  }

  .related-guides__list {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-24);
    margin-top: var(--alias-space-20);

    @include tablet {
      gap: var(--alias-space-16);
    }
  }
</style>
